import { ErrorHero } from '@sunfish/ui';

export default function NotFound() {
	return (
		<ErrorHero
			fullPage
			code="404"
			title="This page swam off."
			body="It happens to the best of us. Let's get you back to open water."
			actionLabel="Back to shore"
			actionHref="/events"
		/>
	);
}
